<button
  type="button"
  tcButton
  [variant]="variant()"
  [size]="size()"
  [ngpMenuTrigger]="menu"
>
  {{ label() }}
  <i class="ri-arrow-down-s-line" aria-hidden="true"></i>
</button>

<ng-template #menu>
  <div ngpMenu [class.tc-dropdown-menu]="items().length > 0" [class.tc-dropdown-panel]="items().length === 0">
    @if (items().length > 0) {
      @for (item of items(); track item.label) {
        <button type="button" ngpMenuItem (click)="item.action()">
          {{ item.label }}
        </button>
      }
    } @else {
      <ng-content />
    }
  </div>
</ng-template>
